// ─── Label Maps ──────────────────────────────────────────────────────────────

export const LABEL_KATEGORI = {
  negara:   "Negara Tujuan Ekspor",
  upt:      "Unit Pelaksana Teknis",
  trader:   "Eksportir",
  kel_ikan: "Komoditas",
};

export const LABEL_ORDER_BY = {
  jumlah:  "Frekuensi",
  netto:   "Volume (Ton)",
  nilaiIDR: "Nilai Rupiah (Juta)",
  nilaiUSD: "Nilai USD",
};

export const MONTH_NAMES = ["JAN","FEB","MAR","APR","MEI","JUN","JUL","AGU","SEP","OKT","NOV","DES"];

// ─── Chart Config Builders ────────────────────────────────────────────────────

const baseChartOptions = (colors) => ({
  chart: { fontFamily: '"Inter", sans-serif', toolbar: { show: false } },
  colors,
  dataLabels: { enabled: false },
  legend: { show: false },
  grid: { show: false },
});

export const buildFrequensiChart = (frequensi, xAxis, colors) => {
  if (!frequensi?.length) return null;

  const categories = xAxis === 1
    ? frequensi.map((d) => d?.TANGGAL)
    : frequensi.map((d) => MONTH_NAMES[d?.BULAN - 1] ?? "-");

  const xFormatter = (_, { dataPointIndex }) => {
    const lbl = xAxis === 1
      ? frequensi[dataPointIndex]?.TANGGAL
      : MONTH_NAMES[frequensi[dataPointIndex]?.BULAN - 1];
    return xAxis === 1 ? `Tanggal ${lbl}` : `Bulan ${lbl}`;
  };

  return {
    options: {
      ...baseChartOptions(colors),
      stroke: { curve: "smooth", width: 3 },
      xaxis: {
        categories,
        labels: { minHeight: 22, maxHeight: 22, style: { colors: "#8A92A6" } },
      },
      yaxis: {
        show: true,
        labels: { show: true, minWidth: 19, maxWidth: 19, style: { colors: "#8A92A6" }, offsetX: -5 },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark", type: "vertical", shadeIntensity: 0,
          inverseColors: true, opacityFrom: 0.4, opacityTo: 0.1,
          stops: [0, 50, 80], colors,
        },
      },
      tooltip: { enabled: true, x: { formatter: xFormatter } },
    },
    series: [{ name: "Jumlah", data: frequensi.map((d) => d?.JUMLAH) }],
  };
};

export const buildVolumeChart = (frequensi, xAxis, colors) => {
  if (!frequensi?.length) return null;

  const categories = xAxis === 1
    ? frequensi.map((d) => d?.TANGGAL ?? "-")
    : frequensi.map((d) =>
        d?.BULAN >= 1 && d?.BULAN <= 12 ? MONTH_NAMES[d.BULAN - 1] : "-"
      );

  const xFormatter = (_, { dataPointIndex }) => {
    const lbl = xAxis === 1
      ? frequensi[dataPointIndex]?.TANGGAL
      : MONTH_NAMES[frequensi[dataPointIndex]?.BULAN - 1];
    return xAxis === 1 ? `Tanggal ${lbl}` : `Bulan ${lbl}`;
  };

  return {
    options: {
      ...baseChartOptions(colors),
      chart: { ...baseChartOptions(colors).chart, stacked: true },
      plotOptions: {
        bar: { horizontal: false, columnWidth: "28%", endingShape: "rounded", borderRadius: 5 },
      },
      stroke: { show: true, width: 2, colors: ["transparent"] },
      xaxis: {
        categories,
        labels: { minHeight: 20, maxHeight: 20, style: { colors: "#8A92A6" } },
      },
      yaxis: { labels: { minWidth: 19, maxWidth: 19, style: { colors: "#8A92A6" } } },
      fill: { opacity: 1 },
      tooltip: {
        x: { formatter: xFormatter },
        y: {
          formatter: (val) =>
            (val / 1000).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Ton",
        },
      },
    },
    series: [{ name: "Volume", data: frequensi.map((d) => d?.NETTO ?? 0) }],
  };
};

export const buildBentukChart = (bentuk) => ({
  options: {
    labels: bentuk.filter((d) => d.ket_bentuk).map((d) => d.ket_bentuk),
    chart: { type: "donut" },
    tooltip: {
      y: {
        formatter: (val) =>
          `${val.toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Ton`,
      },
    },
  },
  series: bentuk.filter((d) => d.ket_bentuk).map((d) => d.totalVolume / 1000),
});
